import { render, staticRenderFns } from "./settlement-set.vue?vue&type=template&id=4dd13f8a&scoped=true&"
import script from "./settlement-set.vue?vue&type=script&lang=js&"
export * from "./settlement-set.vue?vue&type=script&lang=js&"
import style0 from "./settlement-set.vue?vue&type=style&index=0&id=4dd13f8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd13f8a",
  null
  
)

export default component.exports